if (!customElements.get('ampm-supply-picker')) {
  customElements.define('ampm-supply-picker', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.inputs = [...this.querySelectorAll('.ampm-supply__input')];
      this.status = this.querySelector('[data-supply-status]');
      this.addEventListener('change', () => this.update(true), { signal: this.controller.signal });
      this.update(false);
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    update(announce) {
      const selected = this.inputs.find(input => input.checked);
      if (!selected) return;
      this.inputs.forEach(input => {
        input.nextElementSibling?.querySelector('.ampm-supply__expanded')?.setAttribute('aria-hidden', String(!input.checked));
      });
      if (announce && this.status) {
        const title = document.getElementById(selected.getAttribute('aria-labelledby'))?.textContent || '';
        this.status.textContent = `${title}. ${selected.dataset.price}. ${selected.dataset.shipping}.`;
      }
    }
  });
}
